module.exports = "* {\n    font-weight: 700;\n}\n  \n.nav-item {\n    text-align: left;\n    -webkit-transition: all 0.3s ease;\n    transition: all 0.3s ease;\n}\n  \nul>li>a:hover {\n    text-decoration: none;\n    background-color: #15213b !important;\n    border-left: 2px solid #22da54;\n}\n  \n#sidenav-container {\n    border-top: 1px solid #365283;\n    width: calc(100% + 15px);\n}  "


//////////////////
// WEBPACK FOOTER
// ./src/app/gerenciador/sidenavbar/sidenavbar.component.css
// module id = ./src/app/gerenciador/sidenavbar/sidenavbar.component.css
// module chunks = main